import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalBody, ModalHeader, Row, Button, Label } from "reactstrap";
import slugify from "slugify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ShipInfo from "./ShipInfo";
import ShipMethod from "./ShipMethod";
import DeliveryInfo from "./DeliveryInfo";
import Select from "react-select";
import { get, post, put, del } from "../../helpers/api_helper";
import { getPublic, postPublic } from "../../helpers/api_helper";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { INVOICE_TYPE, RenderAmount } from "../../utils";
import toastr from "toastr";
import { useLocation, useNavigate, useParams } from "react-router";
import Loading from "../../components/Loading/loading";
import "./index.scss";
import ExportExcelComponent from "../ListDetailOder/exportExcelComponent";
import ModalConfirm from "../../components/Modal/modalConfirm";
import { getLocationSelectValues } from "./location-options";
import moment from 'moment';
import { checkVAT } from "../../helpers/check-vat";
import { reCalculateDeliveryFee } from "../../helpers/recalculate-delivery-fee";
import { STATUS_TITLE, TIME_FIELD_INVENTORY, STOREFRONT_URL } from "../../constants";

const CANCEL_REASON = [
  {
    "title": "Khách y/c hủy"
  },
  {
    "title": "Đơn ảo"
  },
]
const DEFAULT_ORDER = {
  name: "Khách",
  phone: null,
  email: null,
  province: null,
  ward: null,
  street: '',
  note: null,
  noteInvoice: null,
  typeDelivery: null,
  invoiceType: INVOICE_TYPE.E_VAT_INVOICE_AND_DELIVERY_NOTE,
  costDeliver: null,
  isSendMail: false,
}
const OderManager = () => {
  const refDeliveryInfo = useRef(null)
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { slug } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("CREATE");
  const [statusOder, setStatusOder] = useState("");
  const [idOder, setIdOder] = useState(null);
  const [listProduct, setListProduct] = useState([]);
  const [listProductSelect, setListProductSelect] = useState([{ isNew: true }]);
  const [isLoadingTypeDelivery, setIsLoadingTypeDelivery] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [dataPopupChangeStatus, setDataPopupChangeStatus] = useState(null);
  const [toggleListCostDelivery, setToggleListCostDelivery] = useState(false);
  const [listCostDelivery, setListCostDelivery] = useState([]);
  const [rate, setRate] = useState(null);
  const [isCod, setIsCod] = useState(true);
  const [tempData, setTempData] = useState({});
  const [statusSendMail, setStatusSendMail] = useState(null);
  const [orderData, setOrderData] = useState(null)
  const [cancelReasonIndex, setCancelReasonIndex] = useState(0);
  const [fastError, setFastError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isWarningChangeVATAddress, setIsWarningChangeVATAddress] = useState(false);
  const methods = useForm({
    defaultValues: DEFAULT_ORDER,
    mode: 'onChange'
  });
  // Địa chỉ đơn cũ (3 cấp) không dùng lại được mã tỉnh/phường, hiển thị để chọn lại theo địa chỉ mới
  const [legacyAddressText, setLegacyAddressText] = useState('');
  const {
    handleSubmit,
    setValue,
    formState: { errors, isDirty },
    watch,
    getValues,
    reset,
    register,
  } = methods;

  const isInputFullAdress = () => {
    const { province, street, ward } = getValues();
    if (province?.value && ward?.value && street) {
      return true;
    }
    return false;
  }
  const [isShowShipMethod, setIsShowShipMethod] = useState(isInputFullAdress());


  const watchTypeDelivery = watch("typeDelivery");
  const watchProvince = watch("province")
  const watchWard = watch("ward")
  const watchStreet = watch("street")
  const formRef = useRef(null);
  const exportRef = useRef(null);

  useEffect(() => {
    setIsShowShipMethod(isInputFullAdress())
  }, [watchProvince, watchWard, watchStreet])


  const cloneBillDetail = (billDetails, flagGetVatPercentFromBill = false, flagGetCostFromBill = false) => billDetails.map((item) => ({
    attributeName: item?.ProductAttribute?.attribute,
    cost: flagGetCostFromBill ? item.cost : item.ProductAttribute.cost,
    attributeId: item.ProductAttribute.id,
    productAttributeId: item.ProductAttribute.id,
    productAttributeExternalId: item.ProductAttribute.externalId,
    productId: item.productId,
    productName: item.Product.name,
    vatPercent: flagGetVatPercentFromBill ? item.vatPercent : item.Product.vatPercent,
    unit: item.Product.unit,
    productWeight: item.Product.weight,
    price: item.price,
    productPrice: item.ProductAttribute.price,
    quantity: item.quantity,
    discountPerQuantity: item.discountPerQuantity,
    discount: item.discountPerQuantity > 0,
    discounts: item.Product.discounts,
    saved: true,
    product: item.Product
  }))


  const setFormAndStateFromBill = (bill) => {
    if (bill) {
      setValue("name", bill.name);
      setValue("phone", bill.phone);
      setValue("email", bill.email);
      setValue("note", bill.note);
      setValue("invoiceType", bill.invoiceType);

      setValue("codeVAT", bill.codeVAT);
      setValue("companyNameVAT", bill.companyNameVAT);
      setValue("addressVAT", bill.addressVAT);
      setValue("noteInvoice", bill.noteInvoice);
      setValue("emailReceivedVAT", bill.emailReceivedVAT);
      setValue('costDeliver', null, { shouldDirty: true });

      // setValue("typeDelivery", bill.typeDeliver);
      // setValue("costDeliver", bill.costDeliver);
      // setValue("deposit", bill.deposit);
      // setValue("codeDiscount", bill.codeDiscount);
      if (bill.BillDetails) {
        const cloneListSelect = cloneBillDetail(bill.BillDetails, false, false)
        setListProductSelect(cloneListSelect);
      }
      if (bill.addressDeliver) {
        setValue('street', bill.addressDeliver.street);
        setLegacyAddressText(bill.addressDeliver.district ? (bill.addressDeliver.addressFullText || '') : '');
        getLocationSelectValues(bill.addressDeliver)
          .then(({ province, ward }) => {
            if (province) {
              setValue("province", province);
            }
            if (ward) {
              setTimeout(() => {
                setValue("ward", ward);
              }, 1000);
            }
          })
          .catch(() => { });
      }

      if (bill.codeVAT) {
        checkVAT(bill.codeVAT)
          .then(({ data, error }) => {
            if (!error) {
              if (data.addressVAT !== bill.addressVAT || data.companyNameVAT !== bill.companyNameVAT) {
                setValue("companyNameVAT", data.companyNameVAT);
                setValue("addressVAT", data.addressVAT);
                setIsWarningChangeVATAddress(true)
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }
  useEffect(() => {
    const duplicateId = searchParams.get('duplicateId')
    if (location.state || slug) {
      setLoading(true);
      setStatus('INFO');
      getPublic(`/bills/${location.state?.idBill || slug}`)
        .then((res) => {
          const oder = res.data;
          setOrderData(oder);
          setIdOder(oder.id);
          setStatusOder(oder.status);
          setRate(oder.rate);
          setIsCod(!!oder.isCod);
          setValue("name", oder.name);
          setValue("phone", oder.phone);
          setValue("email", oder.email);
          setValue("note", oder.note || '');
          setValue("codeVAT", oder.codeVAT || '');
          setValue("companyNameVAT", oder.companyNameVAT || '');
          setValue("addressVAT", oder.addressVAT || '');
          setValue("noteInvoice", oder.noteInvoice || '');
          setValue("emailReceivedVAT", oder.emailReceivedVAT || '');
          setValue("codeDiscount", oder.codeDiscount || '');
          setValue("deposit", oder.deposit || 0);
          setValue('costDeliver', oder.costDeliver)
          setValue("street", oder.addressDeliver.street);
          const cloneListSelect = cloneBillDetail(oder.BillDetails, true, true)
          setListProductSelect(cloneListSelect);
          setValue("typeDelivery", oder.typeDeliver);
          setValue('invoiceType', oder.invoiceType);
          setLegacyAddressText(oder.addressDeliver.district ? (oder.addressDeliver.addressFullText || '') : '');
          return getLocationSelectValues(oder.addressDeliver)
            .then(({ province, ward }) => {
              setValue("province", province);
              setValue("ward", ward);
            });
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (duplicateId) {
      get(`/bills/${duplicateId}`, {}).then(
        (bill) => {
          setFormAndStateFromBill(bill)
        }
      )
        .catch(() => {
          setDataKhachVangLai();
        })
    } else {
      setDataKhachVangLai();
    }
    return () => {
      reset(DEFAULT_ORDER);
      setIsCod(false);
      setRate(null);
      setIdOder(null);
      setStatusOder(null);
      setStatus("CREATE");
      setListProductSelect([{ isNew: true }]);
    };
  }, [location, slug]);
  const timeoutSearchLastBillByPhone = useRef();

  const handleChangePhone = (phone) => {
    if (idOder) {
      return
    }
    if (timeoutSearchLastBillByPhone.current) {
      clearTimeout(timeoutSearchLastBillByPhone.current);
    }

    if (phone?.length >= 10) {
      timeoutSearchLastBillByPhone.current = setTimeout(() => {
        get(`/bills/get-last-info-by-phone/${phone}`, {}).then(
          ({
            BillDetails,
            ...bill
          }) => {
            if (bill?.id) {
              setFormAndStateFromBill(bill)
            }
          }
        )
          .catch(() => { })
      }, 300)
    }
  };

  useEffect(() => {
    get(`/products/list?offset=0&limit=10000`).then((data) => {
      setListProduct(data.list);
    });
  }, []);
  const allValues = watch()
  const ignoreFields = ['costDeliver', 'typeDelivery', 'deposit']
  const filteredValues = Object.entries(allValues).filter(([key]) => !ignoreFields.includes(key)).map(e => e[1]);

  useEffect(() => {
    if (!isDirty) {
      return;
    }
    setValue("typeDelivery", null);
    setValue("costDeliver", null);
  }, [
    listProductSelect,
    ...filteredValues,
  ])

  useEffect(() => {
    if (!isDirty) {
      return;
    }

    const { province, ward, street, typeDelivery } = getValues();

    if (status === 'INFO') {
      return;
    }

    // Thương lượng: phí vận chuyển mặc định 0đ
    if (typeDelivery === 'SHOP_SUGGESTION') {
      setValue('costDeliver', 0)
      return;
    }

    if (!isInputFullAdress()) {
      return;
    }
    if (typeDelivery === 'IN_SHOP') {
      setValue('costDeliver', 0)
      return;
    }

    if (isInputFullAdress() && typeDelivery) {
      setIsLoadingTypeDelivery(true);
      postPublic(`/bills/estimate-delivery-fee`, {
        address: {
          province: province ? province.value : "",
          ward: ward ? ward.value : "",
          street,
        },
        typeDeliver: typeDelivery,
        weight: totalWeight(),
        price: refDeliveryInfo?.current?.totalProduct(),
        totalItems: refDeliveryInfo?.current?.totalItems(),
      })
        .then(({ data: { cost } }) => {
          setValue('costDeliver', cost)
        })
        .catch((err) => {
          setValue('costDeliver', null)
          setValue("typeDelivery", null);
          toastr.error(err.response.data.error);
        })
        .finally(() => {
          setIsLoadingTypeDelivery(false);
        });
    }

  }, [watchTypeDelivery]);

  useEffect(() => {
    if (!isOpen || dataPopupChangeStatus?.type !== 'cancel') {
      return;
    }

    setDataPopupChangeStatus({
      ...dataPopupChangeStatus,
      subTitle: renderDesCancelModal(),
    })
  }, [cancelReasonIndex, isOpen, dataPopupChangeStatus]);

  const formatDataProduct = (data) =>
    data.map((item) => ({
      label: item.name,
      value: item.id,
      data: item
    }));

  const formatDataAttribute = (data) =>
    data?.map((item) => ({
      label: item.attribute,
      value: item.id,
      data: item,
    }));

  const addMoreRow = () => {
    const clone = [...listProductSelect];
    clone.unshift({
      isNew: true,
    });
    setValue('costDeliver', null, { shouldDirty: true });
    setListProductSelect(clone);
  };

  const deleteRow = (idx) => {
    const clone = [...listProductSelect];
    clone.splice(idx, 1);
    setValue('costDeliver', null, { shouldDirty: true });
    setListProductSelect(clone);
  };

  const onChangeListProduct = (index, option) => {
    if (option) {
      let cloneListSelect = [...listProductSelect];
      get(`/products/${option.value}`).then((data) => {
        cloneListSelect[index]["listAttributes"] = data.ProductAttributes;
        cloneListSelect[index]["productId"] = data.id;
        cloneListSelect[index]["productName"] = data.name;
        cloneListSelect[index]["vatPercent"] = data.vatPercent;
        cloneListSelect[index]["unit"] = data.unit;
        cloneListSelect[index]["attributeId"] = "";
        cloneListSelect[index]["attributeName"] = "";
        cloneListSelect[index]["productWeight"] = data.weight
        cloneListSelect[index]["discounts"] = data.discounts;
        cloneListSelect[index]["discountPerQuantity"] = 0;
        cloneListSelect[index]["product"] = data;
        setValue('costDeliver', null, { shouldDirty: true });
        setListProductSelect(cloneListSelect);
      });
    }
  };

  const onChangeListAttribute = (index, option) => {
    if (option) {
      let cloneListSelect = [...listProductSelect];
      let attribute = cloneListSelect[index].listAttributes.find(
        (item) => item.id === option.value
      );
      cloneListSelect[index]["productAttributeId"] = attribute.id;
      cloneListSelect[index]["attributeId"] = attribute.id;
      cloneListSelect[index]["attributeName"] = attribute.attribute;
      cloneListSelect[index]["price"] = attribute.price;
      cloneListSelect[index]["cost"] = attribute.cost || 0;
      cloneListSelect[index]["discountPerQuantity"] = 0;
      cloneListSelect[index]["discount"] = false;
      if (cloneListSelect[index]["quantity"] > 0 && cloneListSelect[index]?.discounts) {
        let tempDiscount = cloneListSelect[index]?.discounts.sort((a, b) => b.quantity - a.quantity) || [];
        for (let i = 0; i < tempDiscount.length; i++) {
          if (Number(cloneListSelect[index]["quantity"]) >= tempDiscount[i].quantity) {
            cloneListSelect[index]["discountPerQuantity"] = Number(tempDiscount[i].value);
            cloneListSelect[index]["discount"] = true;
            break;
          }
        }
      } else {
        cloneListSelect[index]["discountPerQuantity"] = 0;
      }
      setValue('costDeliver', null, { shouldDirty: true });
      setListProductSelect(cloneListSelect);
    }
  };

  const onChangeQuantity = (index, value) => {
    let cloneListSelect = [...listProductSelect];
    cloneListSelect[index]["discountPerQuantity"] = 0;
    cloneListSelect[index]["discount"] = false;
    if (cloneListSelect[index]?.discounts) {
      let tempDiscount = cloneListSelect[index]?.discounts.sort((a, b) => b.quantity - a.quantity) || [];

      for (let i = 0; i < tempDiscount.length; i++) {
        if (Number(value) >= tempDiscount[i].quantity) {
          cloneListSelect[index]["discountPerQuantity"] = Number(tempDiscount[i].value);
          cloneListSelect[index]["discount"] = true;
          break;
        }
      }
    }

    cloneListSelect[index]["quantity"] = Number(value);
    setValue('costDeliver', null, { shouldDirty: true });
    setListProductSelect(cloneListSelect);
  };

  const onChangeDiscountPerQuantity = (index, value) => {
    let cloneListSelect = [...listProductSelect];
    cloneListSelect[index]["discount"] = false;
    cloneListSelect[index]["discountPerQuantity"] = Number(value);
    setValue('costDeliver', null, { shouldDirty: true });
    setListProductSelect(cloneListSelect);
  }

  const setDataKhachVangLai = () => {
    setValue("name", 'Khách');
    setValue("phone", '');
    setValue("email", 'thongtinmacdinh@gmail.com');
    setValue('street', '15E Nguyễn Thị Minh Khai');
    setValue("province", {
      label: 'Thành phố Hồ Chí Minh',
      value: 79,
    });
    setValue("ward", {
      label: 'Phường Sài Gòn',
      value: 26740,
    });
  }


  const sendBillMail = () => {
    setStatusSendMail('SENDING');
    post(`/bills/send-mail/${slug}`)
      .then(() => {
        toastr.success('Gửi mail thành công');
        setStatusSendMail(null);
      })
      .catch(() => {
        toastr.error('Gửi mail Không thành công. Vui lòng thử lại');
        setStatusSendMail('OPEN');
      })
  }

  const getListCostDelivery = (isCod) => {
    setToggleListCostDelivery(true)
    setListCostDelivery([])
    post(`/bills/get-list-cost-delivery/${idOder}`, {
      isCod
    }).then((res) => {
      console.log(res)
      setListCostDelivery(res)
    }).catch((err) => {
      toastr.error(err?.error)
    });
  }

  const submitFrom = (data, cb) => {
    let validate = false;
    if (status === "CREATE") {
      let message = '';
      if (listProductSelect.length === 0) {
        message = "Vui lòng chọn sản phẩm";
        validate = true
      }
      listProductSelect.map((item) => {
        if (item.quantity <= 0 || !item.quantity) {
          message = "Số lượng sản phẩm phải lớn hơn 0";
          validate = true
        }
        if (!item.attributeId) {
          message = "Vui lòng chọn thuộc tính cho sản phẩm";
          validate = true
        }
      })
      const totalItems = listProductSelect.reduce((prev, current) => prev + Number(current.quantity), 0);
      if (data.costDeliver > 0 && data.costDeliver !== reCalculateDeliveryFee(data.costDeliver, totalItems)) {
        message = "Vui lòng bấm nút tính lại tiền vận chuyển";
        validate = true
      }
      if (validate) {
        toastr.error(message)
        return;
      }

      setLoading(true);

      post("/bills/create", {
        address: {
          province: data.province.value,
          ward: data.ward.value,
          street: data.street,
        },
        typeDeliver: data.typeDelivery,
        costDeliver: data.costDeliver,
        isSendMail: !!data.isSendMail,

        codeVAT: data.codeVAT || null,
        companyNameVAT: data.companyNameVAT || null,
        addressVAT: data.addressVAT || null,
        noteInvoice: data.noteInvoice || null,
        emailReceivedVAT: data.emailReceivedVAT || undefined,

        invoiceType: data.invoiceType,
        deposit: data.deposit || 0,
        note: data.note || undefined,
        isCod: isCod,
        rate: rate || undefined,
        name: data.name,
        phone: data.phone,
        email: data.email,
        billDetails:
          listProductSelect &&
          listProductSelect.map((item) => ({
            productId: item.productId,
            productAttributeId: item.productAttributeId,
            quantity: Number(item.quantity),
            discount: !!item.discount,
            discountPerQuantity: Number(item.discountPerQuantity || 0),
          })),
      })
        .then((data) => {
          navigate(`/status-oder`)
          toastr.success("Thêm đơn hàng thành công");
        })
        .catch((err) => {
          toastr.error(
            err?.error || "Xảy ra lỗi trong quá trình tạo đơn hàng vui lòng thử lại"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
    if (status === "UPDATE") {
      let message = ''
      if (listProductSelect.length === 0) {
        message = "Vui lòng chọn sản phẩm";
        validate = true
      }
      listProductSelect.map((item) => {
        if (item.quantity <= 0 || !item.quantity) {
          message = "Số lượng sản phẩm phải lớn hơn 0";
          validate = true
        }

        if (!item.attributeId) {
          message = "Vui lòng chọn thuộc tính cho sản phẩm";
          validate = true
        }
      })

      const totalItems = listProductSelect.reduce((prev, current) => prev + Number(current.quantity), 0);
      if (data.costDeliver > 0 && data.costDeliver !== reCalculateDeliveryFee(data.costDeliver, totalItems)) {
        message = "Vui lòng bấm nút tính lại tiền vận chuyển";
        validate = true
      }

      if (validate) {
        toastr.error(message)
        return;
      }
      setLoading(true);
      put(`/bills/update/${idOder}`, {
        address: {
          province: data.province.value,
          ward: data.ward.value,
          street: data.street,
        },
        isCod: isCod,
        rate: rate || undefined,
        typeDeliver: data.typeDelivery,
        costDeliver: data.costDeliver,

        codeVAT: data.codeVAT || null,
        companyNameVAT: data.companyNameVAT || null,
        addressVAT: data.addressVAT || null,
        noteInvoice: data.noteInvoice || null,
        emailReceivedVAT: data.emailReceivedVAT || undefined,
        isSendMail: !!data.isSendMail,
        invoiceType: data.invoiceType,
        deposit: data.deposit || 0,
        note: data.note || "",
        name: data.name,
        phone: data.phone,
        email: data.email,
        billDetails:
          listProductSelect &&
          listProductSelect.map((item) => ({
            saved: !!item.saved,
            productId: item.productId,
            productAttributeId: item.productAttributeId,
            discountPerQuantity: Number(item.discountPerQuantity || 0),
            quantity: Number(item.quantity),
            discount: !!item.discount,
            cost: Number(item.cost || 0),
          })),
      })
        .then((data) => {
          setStatus("INFO");
          setToggleListCostDelivery(null)
          toastr.success("Cập nhật đơn hàng thành công");
          if (typeof cb === 'function') {
            cb();
          } else {
            navigate(0);
          }

        })
        .catch((err) => {
          console.log(err)
          toastr.error(
            err?.error ||
            "Xảy ra lỗi trong quá trình cập nhật đơn hàng vui lòng thử lại"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleCancel = () => {
    setLoading(true);
    post(`/bills/status/cancel/${idOder}`, { cancelReason: CANCEL_REASON[cancelReasonIndex].title })
      .then((res) => {
        navigate("/status-oder");
        toastr.success("Hủy đơn thành công");
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleCreated = (cb) => {
    setLoading(true);
    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.CREATED
    }, {})
      .then((res) => {
        if (res.result) {
          toastr.success("Cập nhật thành công");
          if (cb) {
            cb()
          } else {
            navigate('/status-oder')
            toastr.success("Cập nhật thành công");
          }
        }
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  }

  const handleConfirmed = (cb) => {
    setLoading(true);
    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.CONFIRMED
    }, {})
      .then((res) => {
        if (res.result) {
          toastr.success("Cập nhật thành công");
          if (cb) {
            cb()
          } else {
            navigate('/status-oder')
            toastr.success("Cập nhật thành công");
          }
        }
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handlePreparing = () => {
    setLoading(true);

    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.PREPARING
    }, {})
      .then((res) => {
        if (res.result) {
          navigate(0)
          toastr.success("Cập nhật thành công");
        }
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleCheckPackage = () => {
    setLoading(true);

    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.CHECK_PACKAGE
    }, {})
      .then((res) => {
        if (res.result) {
          navigate(0)
          toastr.success("Cập nhật thành công");
        }
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handlePackageIn = () => {
    setLoading(true);

    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.IN_PACKAGE
    }, {})
      .then((res) => {
        if (res.result) {
          navigate(0)
          toastr.success("Cập nhật thành công");
        }
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleWaitingPay = () => {
    setLoading(true);

    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.WAITING_PAY
    }, {})
      .then((res) => {
        navigate(0)
        toastr.success("Cập nhật thành công");
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleSuccessfulPay = () => {
    setLoading(true);

    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.SUCCESSFUL_PAY
    }, {})
      .then((res) => {
        navigate(0)
        toastr.success("Cập nhật thành công");
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleWaitingExportVAT = () => {
    setLoading(true);

    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.WAITING_EXPORT_VAT
    }, {})
      .then((res) => {
        navigate(0)
        toastr.success("Cập nhật thành công");
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleSuccessfulExportVAT = () => {
    setLoading(true);
    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.SUCCESSFUL_EXPORT_VAT
    }, {})
      .then((res) => {
        navigate(0)
        toastr.success("Cập nhật thành công");
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleDeliver = () => {
    setLoading(true);


    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.TO_SHIPPER
    }, {})
      .then((res) => {
        if (res.result) {
          navigate(0)
          toastr.success("Cập nhật thành công");
        }
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleFinish = () => {
    setLoading(true);

    post(`/bills/scan-inventory/${idOder}`, {
      type: TIME_FIELD_INVENTORY.FINISH_TIME
    }, {})
      .then((res) => {
        if (res.result) {
          navigate(0)
          toastr.success("Cập nhật thành công");
        }
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);

      });
  };

  const handleCreateDraftVAT = () => {
    if (!orderData.invoiceType || !orderData.codeVAT) {
      toastr.error('Vui lòng chọn loại hóa đơn và mã số thuế');
      setIsOpen(false);
      return;
    }
    setLoading(true);
    setFastError(null);
    post(`/bills/create-draft-vat/${idOder}`)
      .then((res) => {
        if (res.result) {
          toastr.success("Tạo bản nháp thành công");
        }
      })
      .catch((err) => {
        toastr.error(err.error);
        setFastError(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);
      });
  };

  const handleDelete = () => {
    setLoading(true);
    del(`/bills/${idOder}`)
      .then(() => {
        navigate('/status-oder')
        toastr.success("Xóa đơn thành công");
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
        setIsOpen(false);
      });
  }

  const saveCostDelivery = async () => {
    handleSubmit(submitFrom)(handleDeliver);
  }

  const customFilter = (option, searchText) => {
    if (searchText === '') {
      return true;
    }
    const slugLabel = slugify((option.label || '').toLowerCase());
    let isIncludes = true;
    let isIncludeTags = false;
    searchText.split(' ').forEach((e) => {
      const temp = slugify(e).toLowerCase();
      isIncludes = slugLabel.includes(temp) && isIncludes;

    });
    if (option.data.data.ProductTags?.length > 0) {
      option.data.data.ProductTags.forEach(({ tag }) => {
        let tempCondition = true;
        const tagNormalize = slugify(tag).toLowerCase();
        searchText.split(' ').forEach((e) => {
          const temp = slugify(e).toLowerCase();
          tempCondition = tagNormalize.includes(temp) && tempCondition;
        });
        isIncludeTags = tempCondition || isIncludeTags;
      })
    }
    return isIncludes || isIncludeTags;
  }

  const totalWeight = () => {
    let total = 0;

    listProductSelect.forEach((item) => {
      total += (item.productWeight || 0) * (item.quantity || 0)
    });

    return total;
  }

  const renderDesCancelModal = () => {
    return <>
      <div>Bạn có chắc chắn muốn hủy đơn hàng này?</div>
      <div >
        Lý do huỷ
      </div>
      {CANCEL_REASON.map((e, i) => <div className="text-start">
        <Label>
          <input type="radio" checked={cancelReasonIndex === i} name="cancelReason" onChange={() => {
            setCancelReasonIndex(i);
          }} />
          {" "}
          {e.title}
        </Label>
      </div>)}
    </>
  }

  return (
    <div className="oder-manager">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitFrom)} ref={formRef}>
          <Breadcrumbs title="Đơn hàng" breadcrumbItem="Đơn hàng">
            <div className={`d-flex justify-content-between align-items-center mt-3 mb-3`} style={{ gap: '20px' }}>
              <h4 className="">Đơn hàng</h4>
              {orderData?.status && <>
                TT Đ.HÀNG:<span className="text-primary" style={{ fontWeight: 'bold', textDecoration: 'underline' }}>  {STATUS_TITLE[orderData.status].toUpperCase()}</span>
              </>}
              {[INVOICE_TYPE.E_VAT_INVOICE, INVOICE_TYPE.E_VAT_INVOICE_AND_DELIVERY_NOTE].includes(orderData?.invoiceType) && <>
                TT XUẤT H.ĐƠN: <span className="text-danger" style={{ fontWeight: 'bold', textDecoration: 'underline' }}>{orderData.isExportVAT ? STATUS_TITLE.SUCCESSFUL_EXPORT_VAT : STATUS_TITLE.WAITING_EXPORT_VAT}</span>
              </>}
            </div>

          </Breadcrumbs>
          {fastError && <div className="alert alert-danger">{fastError?.split('\n').map((e, i) => <div key={`fast-error-${i}`}>{e}</div>)}</div>}

          {loading ? (
            <Loading
              height={50}
              width={50}
              className="loading-custom-page"
              type="spinningBubbles"
            />
          ) : (
            <div className="oder-manager_content">
              {(status === "UPDATE") | (status === "INFO") && idOder ? (
                <p className="mt-3">
                  {`Mã: ${idOder}`}
                  {orderData?.status && (
                    <Button
                      color="link"
                      size="sm"
                      className="p-0 mx-2 align-baseline"
                      onClick={() => {
                        // Link kèm token: khách mở link xem được đầy đủ đơn (đơn nháp thì sửa/đặt hàng được)
                        const tokenQuery = orderData.accessToken ? `?token=${orderData.accessToken}` : '';
                        navigator.clipboard.writeText(`${STOREFRONT_URL}/history/${idOder}${tokenQuery}`)
                          .then(() => toastr.success('Đã copy link đơn hàng'))
                          .catch(() => toastr.error('Không thể copy link'));
                      }}
                    >
                      <i className="bx bx-copy" />
                    </Button>
                  )}
                  {' '}- {moment(orderData.createdAt).format('HH:mm DD-MM-YYYY')}
                </p>
              ) : (
                ""
              )}
              <div className="table-product" style={{
                width: '100%',
                overflowX: 'auto',
                position: 'relative',
              }}>
                <table>
                  <thead>
                    <tr>
                      <th>Tên sản phẩm</th>
                      <th>Thuộc tính</th>
                      <th>Số lượng</th>
                      <th className="text-right">Đơn giá</th>
                      <th className="text-right">Giảm giá</th>
                      <th className="text-right">Giá vốn</th>
                      <th className="text-right">Tổng tiền</th>
                      {status !== "INFO" && (
                        <th>
                          <i
                            onClick={addMoreRow}
                            className="point-click fa fa-plus text-primary"
                          />
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {listProductSelect &&
                      listProductSelect.map((item, idx) => (
                        <tr key={`table-product-${idx}`}>
                          <td>
                            <Select
                              value={
                                item.productId
                                  ? {
                                    value: item.productId,
                                    label: item.productName,
                                    data: item,
                                  }
                                  : {
                                    value: "Chọn sản phẩm",
                                    label: "Chọn sản phẩm",
                                  }
                              }
                              onChange={
                                (option) => {
                                  onChangeListProduct(idx, option)
                                }

                              }
                              placeholder="Chọn sản phẩm"
                              noOptionsMessage={() => "Không tìm thấy"}
                              filterOption={customFilter}
                              options={formatDataProduct(listProduct)}
                              isDisabled={status === "INFO" || item.saved}
                              classNamePrefix="select2-selection"
                              menuPosition="fixed"
                              menuPortalTarget={document.body}
                              styles={{
                                menu: (base) => ({
                                  ...base,
                                  width: "max-content",
                                  maxWidth: "100vw"
                                }),
                              }}
                            />
                            {(!!item.productPrice && item.productPrice !== item.price) ?
                              <>
                                <span className="text-danger">Sản phẩm này bị đổi giá từ <RenderAmount
                                  price={item.price}
                                /> thành <RenderAmount
                                    price={item.productPrice}
                                  /></span>
                              </>
                              : ''}

                          </td>
                          <td>
                            <Select
                              styles={{
                                option: (styles, { data }) => {
                                  return {
                                    ...styles,
                                    color: data?.data?.active ? 'black' : 'red',
                                  };
                                },
                                menu: (base) => ({
                                  ...base,
                                  width: "max-content",
                                  maxWidth: "100vw"
                                }),
                              }}
                              value={
                                item.attributeId
                                  ? {
                                    value: item.attributeId,
                                    label: item.attributeName,
                                  }
                                  : {
                                    label: "Chọn thuộc tính",
                                  }
                              }
                              onChange={(option) => {
                                if (!option?.data?.active) {
                                  toastr.error('Thuộc tính này đang không hoạt động, không thể chọn')
                                  return;
                                }
                                onChangeListAttribute(idx, option)
                              }}
                              placeholder="Chọn thuộc tính"
                              noOptionsMessage={() => "Không tìm thấy"}
                              options={formatDataAttribute(item.listAttributes)}
                              isDisabled={status === "INFO" || item.saved}
                              classNamePrefix="select2-selection"
                              menuPosition="fixed"
                              menuPortalTarget={document.body}

                            />
                          </td>
                          <td>
                            <input
                              value={item.quantity | ""}
                              onChange={(e) => {
                                onChangeQuantity(idx, e.target.value);
                              }}
                              onKeyDown={(event) => {
                                if (event.code === "Enter" || event.code === "NumpadEnter") {
                                  event.preventDefault()
                                  addMoreRow()
                                }
                              }}
                              className="table-product_input"
                              placeholder="Số lượng"
                              disabled={status === "INFO"}
                            />
                          </td>
                          <td className="text-right">
                            {
                              <RenderAmount
                                price={Number(item.price)}
                              />
                            }
                          </td>
                          <td>
                            <input
                              value={item.discountPerQuantity | ""}
                              onChange={(e) => {
                                onChangeDiscountPerQuantity(idx, e.target.value);
                              }}
                              onKeyDown={(event) => {
                                if (event.code === "Enter" || event.code === "NumpadEnter") {
                                  event.preventDefault()
                                  addMoreRow()
                                }
                              }}
                              className="table-product_input"
                              placeholder="Giảm Đ.giá"
                              disabled={status === "INFO"}
                            />
                          </td>
                          <td className="text-right">
                            {
                              <RenderAmount
                                price={Number(item.cost || 0)}
                              />
                            }
                          </td>
                          <td className="text-right">
                            {
                              <RenderAmount
                                price={
                                  item.quantity && item.price
                                    ? Number(item.quantity) * (Number(item.price) - Number(item.discountPerQuantity || 0))
                                    : 0
                                }
                              />
                            }
                          </td>
                          {status !== "INFO" && (
                            <td onClick={() => deleteRow(idx)}>
                              <i className="fa fa-trash text-danger point-click" />
                            </td>
                          )}
                        </tr>
                      ))}

                  </tbody>
                  {/* <tfoot>
                    <tr>
                      <td colSpan={100} className="text-right"><h4>Khối lượng: <RenderAmount price={totalWeight()} decimalScale={3} suffix=" g" /></h4></td>
                    </tr>
                  </tfoot> */}
                </table>
              </div>
              <ShipInfo
                status={status}
                idOder={idOder}
                handleChangePhone={handleChangePhone}
                orderData={orderData}
                legacyAddressText={legacyAddressText}
                isWarningChangeVATAddress={isWarningChangeVATAddress}
              />
              {isShowShipMethod ? <ShipMethod
                listProduct={listProductSelect}
                status={status}
                isLoadingTypeDelivery={isLoadingTypeDelivery}
              /> : ''}

              {rate ?
                <div className="delivery-info">
                  <h5>Thu COD: {!!isCod ? 'Có' : 'Không'}</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <td width={'30%'}>
                          Tên đơn vị
                        </td>
                        <td width={'20%'}>
                          Loại
                        </td>
                        <td width={'30%'}>
                          Thời gian
                        </td>
                        <td width={'20%'}>
                          Giá
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td >
                          <label style={{ display: 'flex', alignItems: 'center' }}>
                            <div>
                              {rate?.carrierLogo ? <>
                                <img height={40} src={rate?.carrierLogo} alt="logo" />
                                <br />
                              </> : ''}
                              {rate?.carrierName}
                            </div>
                          </label>
                        </td>
                        <td>
                          {rate?.service}
                        </td>
                        <td>
                          {rate?.expected}
                        </td>
                        <td>
                          {RenderAmount({ price: rate?.totalFee })}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                : ''}

              <DeliveryInfo
                ref={refDeliveryInfo}
                loading={loading}
                status={status}
                orderData={orderData}
                cancelReason={orderData?.cancelReason}
                isPurchase={orderData?.isPurchase}
                isExportVAT={orderData?.isExportVAT}
                listProduct={listProductSelect}
                statusOder={statusOder}
                statusAllowUpdate={orderData?.statusAllowUpdate}
                handleUpdateStatus={() => setStatus("UPDATE")}
                handleCancel={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    type: 'cancel',
                    title: 'Hủy đơn hàng',
                    subTitle: renderDesCancelModal(),
                    onSuccess: handleCancel
                  })
                }}
                handleDelete={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Xóa đơn hàng',
                    subTitle: 'Bạn có chắc chắn muốn xóa đơn hàng này?',
                    onSuccess: () => handleDelete()
                  })
                }}
                getListCostDelivery={() => {
                  getListCostDelivery(isCod);
                  setStatus('UPDATE')
                  setTempData({
                    isCod,
                    rate,
                  })
                }}
                handleCreated={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Chốt đơn nháp',
                    subTitle: 'Bạn có muốn chốt đơn nháp?',
                    onSuccess: () => handleCreated()
                  })
                }}
                handleConfirmed={(onConfirm) => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Xác nhận đơn hàng',
                    subTitle: 'Bạn có chắc chắn muốn xác nhận đơn hàng này?',
                    onSuccess: () => {
                      handleConfirmed(onConfirm);
                    }
                  })
                }}
                handlePreparing={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Chuẩn bị đơn hàng',
                    subTitle: 'Bạn có muốn chuẩn bị đơn hàng này?',
                    onSuccess: () => handlePreparing()
                  })
                }}

                handleCheckPackage={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'kiểm hàng',
                    subTitle: 'Bạn có muốn kiểm đơn hàng này?',
                    onSuccess: () => handleCheckPackage()
                  })
                }}

                handlePackageIn={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Đóng hàng',
                    subTitle: 'Bạn có muốn đóng gói đơn hàng này?',
                    onSuccess: () => handlePackageIn()
                  })
                }}

                handleDeliver={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Giao vận chuyển hoặc chờ khách đến lấy',
                    subTitle: 'Bạn có chắc chắn muốn chuyển đơn vị vận chuyển hoặc chờ khách đến lấy?',
                    onSuccess: () => handleDeliver()
                  })
                }}

                handleWaitingPay={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Chờ thanh toán',
                    subTitle: 'Bạn có muốn chuyển chờ thanh toán đơn hàng này?',
                    onSuccess: () => handleWaitingPay()
                  })
                }}

                handleSuccessfulPay={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Đã thanh toán',
                    subTitle: 'Bạn có xác nhận đã thanh toán đơn hàng này?',
                    onSuccess: () => handleSuccessfulPay()
                  })
                }}


                handleWaitingExportVAT={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Chờ xuất hoá đơn đỏ',
                    subTitle: 'Bạn có muốn chuyển chờ xuất hoá đơn đỏ đơn hàng này?',
                    onSuccess: () => handleWaitingExportVAT()
                  })
                }}

                handleSuccessfulExportVAT={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Đã xuất hoá đơn đỏ',
                    subTitle: 'Bạn có xác nhận đã xuất hoá đơn đỏ đơn hàng này?',
                    onSuccess: () => handleSuccessfulExportVAT()
                  })
                }}
                handleFinish={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Hoàn thành đơn hàng',
                    subTitle: 'Hoàn thành đơn hàng',
                    onSuccess: () => handleFinish()
                  })
                }}
                handleCreateDraftVAT={() => {
                  setIsOpen(true);
                  setDataPopupChangeStatus({
                    title: 'Tạo bản nháp VAT',
                    subTitle: 'Tạo bản nháp VAT',
                    onSuccess: () => handleCreateDraftVAT()
                  })
                }}

                sendBillMail={() => {
                  setStatusSendMail('OPEN')
                }}
                exportRef={exportRef}
                isShowShipMethod={isShowShipMethod}
                billId={location.state?.idBill || slug}
              />
            </div>
          )}
        </form>
      </FormProvider>
      <div style={{ display: "none" }}>

        <ExportExcelComponent
          ref={exportRef}
          name={orderData?.name}
          phone={orderData?.phone}
          email={orderData?.email}
          id={idOder}
          addressFullText={orderData?.addressDeliver?.addressFullText}
          listProduct={orderData?.BillDetails}
          total={orderData?.total}
          productsAmount={orderData?.productsAmount}
          vatAmount={orderData?.vatAmount}
          costDeliver={orderData?.costDeliver}
          deposit={orderData?.deposit}
          createdAt={orderData?.createdAt}
          note={orderData?.note}
          noteInvoice={orderData?.noteInvoice}
          invoiceType={orderData?.invoiceType}
          codeVAT={orderData?.codeVAT}
          companyNameVAT={orderData?.companyNameVAT}
          addressVAT={orderData?.addressVAT}
        />
      </div>
      <ModalConfirm
        isOpen={isOpen}
        title={dataPopupChangeStatus?.title}
        desc={dataPopupChangeStatus?.subTitle}
        handleCancel={() => setIsOpen(false)}
        handleAccept={dataPopupChangeStatus?.onSuccess}
      />
      <ModalConfirm
        isOpen={!!statusSendMail}
        title={'Ban có chắc sẽ gửi hoá đơn qua email không'}
        desc={''}
        handleCancel={() => setStatusSendMail(null)}
        handleAccept={sendBillMail}
        isLoading={statusSendMail === 'SENDING'}
      />
      <Modal isOpen={toggleListCostDelivery} centered={true} size="lg">
        <ModalHeader className="list-cost-delivery-header">
          {listCostDelivery.length > 0 ? <h5 >Chi phí vận chuyển</h5> : ''}

        </ModalHeader>
        <ModalBody align="center">
          {listCostDelivery.length === 0 ? <h5>Đang lấy dữ liệu, vui lòng chờ</h5> : ''}
          <table className="table table-bordered">
            <thead>
              <tr>
                <td width={'30%'}>
                  Tên đơn vị
                </td>
                <td width={'20%'}>
                  Loại
                </td>
                <td width={'30%'}>
                  Thời gian
                </td>
                <td width={'20%'}>
                  Giá
                </td>
              </tr>
            </thead>
            <tbody>

              {listCostDelivery.map((e) =>
                <tr>
                  <td >
                    <label style={{ display: 'flex', alignItems: 'center' }}>
                      <div>
                        <input type="radio" name="goship-delivery-type" onChange={() => {
                          setRate(e)
                        }}
                          checked={rate && e.id === rate.id}

                        />
                        {e.carrierLogo ? <>
                          <img height={40} src={e.carrierLogo} alt="logo" />
                          <br />
                        </> : ''}
                        {e.carrierName}
                      </div>
                    </label>
                  </td>
                  <td>
                    {e.service}
                  </td>
                  <td>
                    {e.expected}
                  </td>
                  <td>
                    {RenderAmount({ price: e.totalFee })}
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={`2`}>
                  <div className="d-flex">
                    <div>
                      Tổng tiền: {RenderAmount({ price: refDeliveryInfo?.current?.restTotal() })}
                    </div>
                    <div className="cod ms-5">COD:
                      <input
                        checked={!!isCod}
                        type='checkbox'
                        onClick={() => {
                          setIsCod(!isCod)
                          setRate(null)
                          getListCostDelivery(!isCod)
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td colSpan={`2`} style={{ textAlign: 'right' }} className="w-100 pt-2">
                  <Button
                    style={{ marginRight: 5 }}
                    className="btn btn-success"
                    onClick={saveCostDelivery}
                    disabled={rate === null}
                  >Gửi vận chuyển</Button>
                  <Button className="btn btn-danger" onClick={() => {
                    setToggleListCostDelivery(false);
                    setStatus('INFO');
                    setRate(tempData?.rate);
                    setIsCod(tempData?.isCod);
                  }}>X</Button>

                </td>
              </tr>
            </tfoot>

          </table>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default OderManager;
